/**
 * <coffre-du-clan> — Le Coffre du Clan.
 *
 * S'appuie sur les labels de variantes déjà rendus par product-variant-options.liquid
 * (label.pack[data-variant-id][data-days], classe .sel sur la variante active) : c'est
 * la seule source de vérité pour "combien de jours cette variante représente", évitant
 * de dupliquer ce calcul en JS. product-info.js émet 'mb:variant-change' (document) à
 * chaque changement de variante, sans détail — on relit simplement le DOM à ce moment-là.
 */
class CoffreDuClan extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.productId = this.dataset.productId;

    this.stateEl = this.querySelector('[data-coffre-state]');
    this.slotsEl = this.querySelector('[data-coffre-slots]');

    const configEl = this.querySelector('[data-coffre-config]');
    try {
      this.config = configEl ? JSON.parse(configEl.textContent) : { gifts: [] };
    } catch (e) {
      this.config = { gifts: [] };
    }

    this.onVariantChange = this.render.bind(this);
    document.addEventListener('mb:variant-change', this.onVariantChange);

    // Premier rendu potentiel si la sélection a déjà bougé côté client avant que ce
    // composant ne soit connecté (ex: quick add pré-sélectionné).
    this.render();
  }

  disconnectedCallback() {
    document.removeEventListener('mb:variant-change', this.onVariantChange);
  }

  getVariantSelects() {
    return document.getElementById(`variant-selects-${this.sectionId}-${this.productId}`);
  }

  render() {
    const variantSelects = this.getVariantSelects();
    if (!variantSelects || !this.slotsEl) return;

    const selectedLabel = variantSelects.querySelector('label.pack.sel');
    const selectedDays = selectedLabel ? parseFloat(selectedLabel.dataset.days) || 0 : 0;

    let unlockedCount = 0;
    let bestDays = -1;
    let bestGiftVariantId = null;

    const slots = Array.from(this.slotsEl.querySelectorAll('[data-coffre-slot]'));

    slots.forEach((slot) => {
      const slotDays = parseFloat(slot.dataset.days) || 0;
      const wasOpen = !slot.classList.contains('pc-slot--locked');
      const isOpen = selectedDays >= slotDays;

      if (isOpen) {
        unlockedCount += 1;
        if (slotDays > bestDays) {
          bestDays = slotDays;
          bestGiftVariantId = slot.dataset.variantId;
        }
      }

      if (isOpen === wasOpen) return;

      slot.classList.toggle('pc-slot--locked', !isOpen);
      const box = slot.querySelector('.pc-slot__box');
      if (isOpen && box) {
        box.classList.remove('pc-justopen');
        // Force reflow pour rejouer l'animation même si la classe vient d'être retirée.
        void box.offsetWidth;
        box.classList.add('pc-justopen');
      }
    });

    if (this.stateEl) {
      const gift = this.config.gifts.find((g) => String(g.variantId) === String(bestGiftVariantId));
      const left = slots.length - unlockedCount;
      if (gift && gift.etatTexte) {
        this.stateEl.innerHTML = gift.etatTexte;
      } else if (left > 0) {
        this.stateEl.textContent = '';
      }
    }
  }
}

customElements.define('coffre-du-clan', CoffreDuClan);
